import React from 'react'
import { navigate } from 'gatsby'
import cn from 'classnames'

import Button from '~components/Button'
import homeImg from '~img/home-lg.png'
import homeMobileImg from '~img/home-mobile.png'
import * as s from './SectionCta.module.scss'

const SectionCta = () => {
  return (
    <section
      className={cn(s.sectionCta, 'flex justify-center mx-4 mb-4 md:mt-48')}
    >
      <div className="w-full max-w-[1360px]">
        <div className={s.titles}>
          <h2 className={s.title}>
            #WATCH
            <strong>2</strong>
            EARN
          </h2>
          <p className={s.subtitle}>
            Earn rewards by watching your favorite YouTubers.
          </p>
          <Button
            size="sm"
            variant="filled"
            title="Download Now"
            className={s.ctaButton}
            onClick={() => navigate('/plugin')}
          />
        </div>
        <div className={s.imgContainer}>
          <img src={homeImg} alt="wallet" className={cn(s.walletImg, 'z-10')} />
          <img
            src={homeMobileImg}
            alt="wallet mobile"
            className={s.walletImgMobile}
          />
        </div>
      </div>
    </section>
  )
}

export default SectionCta
